import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { syncStateWithUrl } from '../actions/searchAction';
import Results from './Results';
import Loader from '../../common/Loader';
import SearchBanner from './SearchBanner';

const InspirationPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(syncStateWithUrl())
    setIsLoading(false);
  }, [])

  return (
    <div className="crtSearchInspirationPage">
      <SearchBanner />

      { isLoading ? <Loader /> : <Results /> }
    </div>
  );
};

export default InspirationPage;
